import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Resets scroll to the top on every SPA route change (pathname), so links —
 * e.g. the Footer, which sits at the bottom of the page — don't land the next
 * page scrolled down. Skips when the URL carries a hash, so in-page anchor
 * navigation still jumps to its target. Renders nothing.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
